import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { NoteSearchModel } from '../models/note-related/NoteSearchModel';
import { ActivityWidgetContainerService } from './activity-widget-container.service';
import { ActivitySearchModel } from '../models/activity-related/ActivitySearchModel';
import { ActivityCreateModel } from '../models/activity-related/ActivityCreateModel';
import { ContactActionModel } from '../models/contact-related/ContactActionModel';
import { PreloaderHandler, BLUE_FULL } from '../preloader/preloader-handler';
import { ContactListModel } from '../models/contact-related/ContactListModel';
import { PopulateFormService } from '../../services/populate-form';
import { SheetComponent } from '../sheet-export-import/sheet-export-import.component';
import { NotificationHandlerService } from '../notifications/notification-handler.service';

@Component({
    selector: 'activity-widget-container',
    templateUrl: 'activity-widget-container.component.html'
})

export class ActivityWidgetContainerComponent implements OnInit {

    @Input() entityId: string;
    public allActivities: ActivitySearchModel[];
    private newActivity: ActivityCreateModel;
    public preloaderHandler: PreloaderHandler;

    private showCreate = false;
    private contactList: ContactListModel[];
    private contactActionList: ContactActionModel[];

    constructor(private _formService: PopulateFormService,
        private _notificationService: NotificationHandlerService,
        private _widgetService: ActivityWidgetContainerService,
        public oidcSecurityService: OidcSecurityService) {
        let timeout = 850;
        let itemLoadCount = 1;
        this.preloaderHandler = new PreloaderHandler(itemLoadCount, timeout, BLUE_FULL);
    }

    ngOnInit(): void {
        this.getFormData();
        this.getData();
    }

    public isNoActivity(): boolean {
        return (!this.allActivities || this.allActivities.length < 1);
    }

    public getData(): void {
        this.allActivities = null;
        this.newActivity = null;
        this._widgetService
            .Get(this.entityId)
            .subscribe(data => {
                this.allActivities = data
            },
            error => {
                this.oidcSecurityService.handleError(error),
                    this._notificationService.handleError(error)
            },
            () => { });
    }

    public exportSheet(data: ActivitySearchModel): void {
    }

    private toggleCreate(): void {
        this.showCreate = !this.showCreate;
        if (this.showCreate) {
            this.newActivity = {
                EntityId: this.entityId,
                ContactId: '',
                Activity: ''
            }
            this.preloaderHandler.itemLoaded();
        } else {
            this.newActivity = null;
            this.preloaderHandler.reset();
        }
    }

    private newActivityIsValid(): boolean {
        return (this.newActivity.Activity.length > 0 && this.newActivity.ContactId.length > 0);
    }

    private removeActivity(data: ActivitySearchModel): void {
        let index: number = this.allActivities.indexOf(data);
        if (index !== -1) {
            this.allActivities.splice(index, 1);
        }
    }

    private saveData(): void {
        if (this.newActivityIsValid()) {
            this.preloaderHandler.reset();
            this._widgetService
                .Create(this.newActivity)
                .subscribe(data => {
                },
                error => {
                    this.oidcSecurityService.handleError(error),
                    this._notificationService.handleError(error)
                },
                () => {
                    this.toggleCreate(),
                    this.preloaderHandler.itemLoaded(),
                    this.getData()
                });
        }
    }

    private getFormData(): void {
        this._formService
            .GetContactSelectList()
            .subscribe(data => {
                this.contactList = data
            },
            error => {
                this.oidcSecurityService.handleError(error),
                this._notificationService.handleError(error)
            },
            () => {});

        this._formService
            .GetContactActionSelectList()
            .subscribe(data => {
                this.contactActionList = data
            },
            error => {
                this.oidcSecurityService.handleError(error),
                    this._notificationService.handleError(error)
            },
            () => { });
    }
}



// WEBPACK FOOTER //
// ./angularApp/app/shared/activity-widget-container/activity-widget-container.component.ts